import type { LocationAssetsListProps } from "./location-assets-list.type";

import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import { ASSETS_FILTERS, ASSETS_METADATA } from "@/entities/assets";
import { ListProvider } from "@/modules/list";

import { LocationAssetsListTable } from "./location-assets-list-table";
import { LocationAssetsListWidgets } from "./location-assets-list-widgets";

const LocationAssetsList = ({ location, loading }: LocationAssetsListProps) => {
  return (
    <ListProvider
      endpoint="assets"
      loading={loading}
      storageKey={STORAGE_KEYS.LOCATIONS_ASSETS}
      contextTabValue={TAB_KEYS.LOCATION_ASSETS}
      withMetadata={[ASSETS_METADATA.STATISTICS]}
      hiddenFilters={{
        [ASSETS_FILTERS.LOCATION_ID]: location?.id ?? "",
        [ASSETS_FILTERS.ASSET_ID]: "null",
      }}
    >
      <LocationAssetsListWidgets>
        <LocationAssetsListTable location={location} loading={loading} />
      </LocationAssetsListWidgets>
    </ListProvider>
  );
};

export default LocationAssetsList;
